import { DialogActionsBar } from '@progress/kendo-react-dialogs';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import Button from 'src/components/design-system/Button';
import Dialog from 'src/components/design-system/Dialog';
import { ExternalCatalogResponse } from 'src/services/catalog_products/useGetExternalCatalogMutation';

interface PunchoutErrorDialogProps {
  // The failed external-catalog response; the dialog is open while this is set.
  response: ExternalCatalogResponse | null;
  onClose: VoidFunction;
}

const PunchoutErrorDialog: FC<PunchoutErrorDialogProps> = ({ response, onClose }) => {
  const { t } = useTranslation();

  return (
    <Dialog width="500px" onClose={onClose} open={response !== null} title={t('Error')} id="modal">
      <div className="p-0 text-sm" data-testid="punchout-error-dialog">
        <p className="mb-2 break-words">
          {t('punchoutErrorStatusCode', { statusCode: response?.supplierStatusCode ?? '' })}
        </p>
        <p className="mb-2 whitespace-pre-wrap break-words">{response?.statusText}</p>
        <p>{t('Please contact support for more information.')}</p>
      </div>
      <DialogActionsBar>
        <div className="flex items-center justify-end">
          <Button color="info" onClick={onClose}>
            {t('Ok')}
          </Button>
        </div>
      </DialogActionsBar>
    </Dialog>
  );
};

export default PunchoutErrorDialog;
